export class TransferRequestInfo {
  static readonly STATUS_ACTIVE = 'ACTIVE';
  static readonly BATCH_SIZE_STYLES = 50;
  static readonly BATCH_SIZE_DUPLICATES = 30;
  static readonly MAX_RETRIES = 3;
  static readonly RETRY_DELAY_BASE_MS = 1000;
}
